import React from 'react';
import './pagination.less';
import styled from 'styled-components';
import MUIPagination from '@mui/material/Pagination';
import { MuiMenuItem, DeprecatedLabeledSelect } from '@fox/atoms';

export const DefaultPageSizeOptions = [20, 50, 100, 1000];
export interface IPaginationProps {
	onChange: (page: number, pageSize: number) => void;
	total?: number;
	current?: number;

	pageSize: number;
	pageSizeOptions?: number[];
}

const PaginationWrap = styled.div`
	display: flex;
	gap: 10px;
	margin-top: 10px;
`;

export const Pagination = (props: IPaginationProps) => {
	const pageSize = props.pageSize;

	if (!props.total) {
		return null;
	}

	return (
		<PaginationWrap>
			<div
				style={{
					marginTop: 'auto'
				}}
			>
				<MUIPagination
					siblingCount={3}
					boundaryCount={1}
					onChange={(e, page) => {
						if (page !== null && page !== undefined) props.onChange(page, pageSize);
					}}
					page={props.current}
					count={Math.ceil(props.total / pageSize)}
					variant="outlined"
					shape="rounded"
				/>
			</div>
			{props.pageSizeOptions && (
				<DeprecatedLabeledSelect
					style={{
						width: 100
					}}
					onChange={c => {
						props.onChange(1, Number(c.target.value));
					}}
					value={pageSize?.toString()}
					label="Rows per page"
				>
					{props.pageSizeOptions.map(o => {
						return (
							<MuiMenuItem key={o} value={o.toString()}>
								{o}
							</MuiMenuItem>
						);
					})}
				</DeprecatedLabeledSelect>
			)}
		</PaginationWrap>
	);
};